import { Tooltip } from 'antd';
import { hexAlpha } from '../../utils/colorUtils';

export const EstadoPagoChip = ({ nombre, descripcion, color }) => {
  if (!nombre) return null;
  const c = color || '#9e9e9e';
  return (
    <Tooltip title={descripcion || ''} placement="top">
      <span style={{
        display: 'inline-flex', alignItems: 'center',
        padding: '3px 10px', borderRadius: 20,
        border: `1.5px solid ${c}`,
        background: hexAlpha(c, 0.1),
        color: c,
        fontSize: 12, fontWeight: 600,
        whiteSpace: 'nowrap', cursor: descripcion ? 'help' : 'default',
      }}>
        {nombre}
      </span>
    </Tooltip>
  );
};
